import { createStyles, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { TnButton } from '../TnButton';

export interface ConfirmOnlyFooterDetails {}

interface ConfirmOnlyFooterProps extends ConfirmOnlyFooterDetails {
  handleConfirmPressed: () => void;
  shouldEnableConfirmButton: boolean;
  confirmButtonTitle: string;
  isLoading: boolean;
}

const ConfirmOnlyFooter = ({
  confirmButtonTitle,
  handleConfirmPressed,
  shouldEnableConfirmButton,
  isLoading,
}: ConfirmOnlyFooterProps) => {
  const classes = useStyles();

  return (
    <Grid className={classes.footerContainer}>
      <TnButton
        title={confirmButtonTitle}
        variant="contained"
        color="primary"
        disabled={!shouldEnableConfirmButton || isLoading}
        onClick={handleConfirmPressed}
        value={confirmButtonTitle}
      />
    </Grid>
  );
};

export default ConfirmOnlyFooter;

const useStyles = makeStyles(() =>
  createStyles({
    footerContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginLeft: 32,
      marginRight: 32,
      marginTop: 24,
      marginBottom: 24,
    },
  }),
);
